// Normalizes a field value for duplicate comparison without altering the
// displayed value: coerces to string, trims, and collapses internal
// whitespace so values that render identically (e.g. "ABC" vs "ABC ") are
// recognized as the same value.
const normalizeForComparison = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).trim().replace(/\s+/g, " ");
};

// Removes rows that are exact duplicates across every field (normalized),
// keeping the first occurrence. Rows that differ in any field are kept.
export const dedupeExactRows = (rows) => {
  const seen = new Set();
  return rows.filter((row) => {
    const key = Object.keys(row)
      .sort()
      .map((field) => `${field}:${normalizeForComparison(row[field])}`)
      .join("|");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};